import { render } from "./SavePage.vue?vue&type=template&id=4feb6a83&scoped=true"
import script from "./SavePage.vue?vue&type=script&lang=js"
export * from "./SavePage.vue?vue&type=script&lang=js"

import "./SavePage.vue?vue&type=style&index=0&id=4feb6a83&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4feb6a83"

export default script